import React, {Suspense} from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import App from "./app";
import {BrowserRouter} from "react-router-dom";
import './i18next';
import {Provider} from "react-redux";
import store from "./store/store";
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from "react-toastify";

ReactDOM.render(
	<Suspense fallback="...">
	<React.StrictMode>
		<BrowserRouter>
			<Provider store={store}>
				<ToastContainer
					position="top-right"
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop
					closeOnClick
					rtl={false}
					pauseOnFocusLoss={false}
					draggable
					pauseOnHover={false}/>
			  <App/>
			</Provider>
		</BrowserRouter>
	 </React.StrictMode>
	</Suspense>,
	document.getElementById('root')
)
